import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { SendDocumentsClientResponse } from '../@types/SendDocumentsByEmail'

type Store = {
  sendDocumentsByEmail: SendDocumentsClientResponse | null
  setSendDocumentsByEmail: (value: SendDocumentsClientResponse) => void
}

export const useSendDocumentsByEmailStore = create<Store>()(
  devtools(
    (set) => ({
      sendDocumentsByEmail: null,
      setSendDocumentsByEmail: (sendDocumentsByEmail) =>
        set({ sendDocumentsByEmail }),
    }),
    { name: 'SendDocumentsByEmailStore' },
  ),
)
